import React, { useEffect, useState } from 'react'
import { Panel, Icon, Avatar, Row, Col, FlexboxGrid } from 'rsuite'
import { Link } from 'react-router-dom'
import './animation.less'
import { cloneDeep } from 'lodash-es'
import DashboradToggle from './DashboradToggle'
import pathname from '../../constants/pathname'

export default function StatusWidget({
  datas,
  showLine = true,
  dashBoardName,
  masterConfigKey,
  config,
  configResult,
  onSettingChange = () => {},
  colSize = 4,
  url,
}) {
  const [shows, setShows] = useState([])
  const lgSize = Math.ceil(24 / colSize)
  const defaultTheme = (localStorage.getItem('theme') || 'default') == 'default'

  useEffect(() => {
    let arr = []

    datas?.forEach((e, index) => {
      arr.push(true)
    })

    setShows(arr)
  }, [datas])

  const handleClickShow = (index) => {
    var datas = cloneDeep(shows)

    datas[index] = !datas[index]

    setShows(datas)
  }

  const onClick = (masterkey, key, status) => {
    if (!config) {
      sessionStorage.setItem('up-down-strem-master-key', masterkey || '')
      sessionStorage.setItem('up-down-strem-key', key || '')
      sessionStorage.setItem('up-down-strem-status', status || '')

      window.open(url ? url : pathname.ProjectBudgetReport)
    }
  }

  return (
    <>
      {datas && (
        <>
          {datas.map((item, index) => {
            return (
              <>
                {/* <Col lg={6} md={12} sm={12} xs={24}> */}
                <FlexboxGrid.Item
                  componentClass={Col}
                  colspan={24}
                  lg={index + 1 == datas.length && colSize != 4 ? lgSize - 1 : lgSize}
                  md={12}
                  sm={12}
                  xs={24}
                >
                  {config && (
                    <DashboradToggle
                      onChange={onSettingChange}
                      // dashboradName={
                      //   config?.find((e) => e.key == `${masterConfigKey}_${item.key}`)?.key
                      // }
                      // checked={config?.find((e) => e.key == `${masterConfigKey}_${item.key}`)?.show}
                      dashboradName={config?.find((e) => e.key == item.key)?.key}
                      checked={configResult?.find((e) => e.key == item.key)?.show}
                      style={{ marginTop: 20, marginBottom: -10, marginLeft: 10 }}
                    />
                  )}
                  <div
                    class={
                      index == datas.length - 1 || !showLine
                        ? 'container-dashboard-status-last'
                        : 'container-dashboard-status'
                    }
                  >
                    <div
                      class={index == datas.length - 1 || !showLine ? '' : 'box-dashboard-status'}
                    >
                      <Avatar
                        circle
                        size="md"
                        style={{
                          marginTop: 0,
                          backgroundColor: item.countColor,
                          color: '#4caf50',
                          cursor: item.count > 0 ? 'pointer' : 'default',
                          fontSize: '1.2rem',
                          fontWeight: 700,
                        }}
                        onClick={() => {
                          if (item.count > 0) {
                            onClick(item.key, '', item.name)
                          }
                        }}
                      >
                        <b style={{ color: 'white' }}>{item.count}</b>
                      </Avatar>

                      {item.warning && (
                        <Icon
                          // size="sm"
                          className="animation"
                          style={{ color: '#F44336' }}
                          icon={'exclamation-triangle'}
                        />
                      )}
                      <span
                        style={{
                          // fontSize: '1.0rem',
                          backgroundColor: 'transparent',
                          marginBottom: 10,
                          marginLeft: 5,
                          cursor: item.count > 0 ? 'pointer' : 'default',
                          paddingRight: 10,
                        }}
                        onClick={() => {
                          if (item.count > 0) {
                            onClick(item.key, '', item.name)
                          }
                        }}
                      >
                        <span style={{ fontSize: '1.0rem', fontWeight: 600 }}>{item.name}</span>
                      </span>
                      <span style={{ paddingRight: 10 }}>
                        {dashBoardName == 'coodinatorSummary' && item.details?.length > 0 && (
                          <Icon
                            style={{
                              color: item.countColor,
                              cursor: 'pointer',
                              // zIndex: 999,
                            }}
                            size="lg"
                            icon={shows[index] ? 'chevron-circle-up' : 'chevron-circle-down'}
                            onClick={() => handleClickShow(index)}
                          />
                        )}
                      </span>
                    </div>
                  </div>
                  <div>
                    {dashBoardName == 'coodinatorSummary' && item.details?.length > 0 && (
                      <>
                        {shows[index] && (
                          <>
                            <Panel
                              header=""
                              bordered
                              // collapsible
                              // defaultExpanded={item.details?.length > 0}
                              style={{
                                backgroundColor: item.countColor,
                                //marginTop: index == datas.length - 1 || !showLine ? 20 : 0,
                                marginLeft: 30,
                                marginTop: -15,
                              }}
                            >
                              {item.details?.length > 0 && (
                                <Panel
                                  style={{
                                    marginLeft: -10,
                                    marginRight: -10,
                                    // marginTop: -10,
                                    marginBottom: -10,
                                  }}
                                >
                                  <Row style={{ marginTop: -10, marginBottom: -15 }}>
                                    {item.details?.map((e) => {
                                      return (
                                        <>
                                          <Row
                                            style={{
                                              marginTop: 5,
                                              marginLeft: -5,
                                              marginRight: -5,
                                            }}
                                          >
                                            <Icon
                                              //size="lg"
                                              icon={item.icon}
                                              style={{
                                                // background: e.warning ? '#FF5733' : '#f1f1f1',
                                                cursor: 'pointer',
                                                color: e.warning
                                                  ? '#FF5733'
                                                  : defaultTheme
                                                  ? '#595959'
                                                  : '#e9ebf0',
                                              }}
                                            />

                                            {config ? (
                                              <span
                                                className="font-color"
                                                style={{
                                                  // color: '#595959',
                                                  marginLeft: 10,
                                                }}
                                                // disabled={config}
                                                // onClick={() => {
                                                //   onClick(item.status, e.status)
                                                // }}
                                              >
                                                {e.name}
                                                <span
                                                  style={{ fontSize: '1.2rem', fontWeight: 700 }}
                                                >
                                                  {` (${e.count}) `}
                                                </span>
                                                {e.warning && (
                                                  <Icon
                                                    className="animation"
                                                    style={{ color: '#F44336' }}
                                                    icon={'exclamation-triangle'}
                                                  />
                                                )}
                                              </span>
                                            ) : (
                                              <a
                                                className="font-color"
                                                style={{
                                                  // color: '#595959',
                                                  marginLeft: 10,
                                                  cursor: 'pointer',
                                                }}
                                                onClick={() => {
                                                  if (e.count != null && e.count > 0) {
                                                    onClick(item.key, e.key, e.name)
                                                  }
                                                }}
                                              >
                                                {e.name}
                                                <span
                                                  style={{ fontSize: '1.2rem', fontWeight: 600 }}
                                                >
                                                  {` (${e.count}) `}
                                                </span>
                                                {e.warning && (
                                                  <Icon
                                                    className="animation"
                                                    style={{ color: '#F44336' }}
                                                    icon={'exclamation-triangle'}
                                                  />
                                                )}
                                              </a>
                                            )}
                                          </Row>
                                        </>
                                      )
                                    })}
                                  </Row>
                                </Panel>
                              )}
                            </Panel>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </FlexboxGrid.Item>
                {/* </Col> */}
              </>
            )
          })}
        </>
      )}
    </>
  )
}
